"use client";

import Input from "@/components/ui/Input";
import { cn } from "@/lib/utils";
import { formatNumberWithCommas } from "@/utils/formatNumberWithCommas";
import { useTranslation } from "react-i18next";

const AmountInput = ({
  register,
  setValue,
  error,
  errorMessage,
  className,
  containerClassName,
  label,
  formKey = "amount",
  ...props
}) => {
  const { t } = useTranslation("common");
  const handleAmountChange = event => {
    const value = event.target.value.replace(/,/g, "");
    const formattedValue = formatNumberWithCommas(value);
    setValue(formKey, formattedValue);
    event.target.value = formattedValue;
  };

  return (
    <label className={cn("block mt-3", containerClassName)}>
      <span className="block font-medium"> {label ?? t("amount")}</span>
      <Input
        {...register}
        onChange={handleAmountChange}
        type="text"
        error={error}
        placeholder={t("amount")}
        inputMode="decimal"
        className={className}
        errorMessage={errorMessage}
        {...props}
      />
    </label>
  );
};

export default AmountInput;
